import { View } from "react-native";
import TextLoader from "../shared/TextLoader";
import React from "react";
import TipLoader from "./TipLoader";
import ContentScrollBarLoader from "../shared/ContentScrollBar/ContentScrollBarLoader";
import RAccordionLoader from "../shared/RAccordionLoader";
import Gap from "../../../../Gap";

const FutureTipsLoader = () => {
  return (
    <View>
      <Gap vertical size="xsmall" />
      <TextLoader height={20} />
      <Gap vertical size="small" />
      <ContentScrollBarLoader />
      <Gap vertical size="xsmall" />
      <TextLoader height={36} />
      <TipLoader />
      <RAccordionLoader />
    </View>
  );
};
export default FutureTipsLoader;
